
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/oembed/rles",
      function () {
        return require("private-next-pages/apipages/oembed/rles/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/oembed/rles"])
      });
    }
  